import React, { useState } from "react";
import UI from "@mile-meeting/mile-ui";
import styled from "@emotion/styled";

interface RoomDetailInfoFieldProps {
  detailInfo: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const RoomDetailInfoField: React.FC<RoomDetailInfoFieldProps> = ({ detailInfo, onChange, disabled = false }) => {
  const [value, setValue] = useState(detailInfo);

  const handleChange = (value: string) => {
    if (value.length > 1000) return;
    onChange(value);
    setValue(value);
  };

  return (
    <Container>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        상세 정보
      </UI.Typography>
      <UI.Input
        multiline
        height={178}
        disabled={disabled}
        placeholder="회의실 상세 정보"
        value={value}
        showMaxLength
        maxLength={1000}
        onChange={handleChange}
      />
    </Container>
  );
};

export default React.memo(RoomDetailInfoField);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RequiredAsterisk = styled.span`
  color: var(--alias-color-primary-normal);
`;
